<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    // provide / inject 组合使用
    // 任意组价内使用
    // 在 export default 中声明 inject: ['reload']  直接this.reload()调用即可
    provide() {
      return {
        reload: this.reload,
      }
    },
    data() {
      return {
        isRouterAlive: true,
      }
    },
    methods: {
      // 刷新页面
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(() => this.isRouterAlive = true);
      },
    }
  }
</script>

<style lang="less" scoped>

</style>